import React, { Component } from 'react'
import { connect } from 'react-redux'
import { requireAuthentication } from '../helpers/authentication'
import {
  getUserIsSaving,
  getEditingUser,
  getUserIsLoading,
  getCustomUsersAttributes,
} from '../selectors/users'
import {
  requestUserUpdating,
  fetchEditingUser,
  fetchCustomAttributes,
} from '../thunks/users'
import Forbidden from '../components/Forbidden'
import MustHave from '../containers/MustHave'
import { EditUser } from '../components/Users'
import Loading from '../components/Loading'
import { getIsExternalProvider } from '../selectors/user'

class UserEditContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      editingUserFetched: false,
      customAttributesFetched: false,
    }
  }

  componentDidMount() {
    const { fetchEditingUser, fetchCustomAttributes } = this.props
    fetchEditingUser().then((res) => {
      this.setState({ editingUserFetched: true })
    })
    fetchCustomAttributes().then((res) => {
      this.setState({ customAttributesFetched: true })
    })
  }
  render() {
    const { editingUserFetched, customAttributesFetched } = this.state
    const { isLoading } = this.props
    if (isLoading || !editingUserFetched || !customAttributesFetched) {
      return <Loading />
    }

    return (
      <MustHave
        permission="page-user-administration:get"
        fallback={<Forbidden />}
      >
        <EditUser {...this.props} />
      </MustHave>
    )
  }
}

const mapState = (
  state,
  {
    match: {
      params: { userId },
    },
  },
) => {
  return {
    userId,
    editingUser: getEditingUser(state),
    externalProvider: getIsExternalProvider(state),
    isSaving: getUserIsSaving(state),
    isLoading: getUserIsLoading(state),
    customAttributes: getCustomUsersAttributes(state),
  }
}

const mapDispatch = (
  dispatch,
  {
    match: {
      params: { userId },
    },
  },
) => {
  return {
    updateUser: (values) => dispatch(requestUserUpdating(userId, values)),
    fetchEditingUser: () => dispatch(fetchEditingUser(userId)),
    fetchCustomAttributes: () => dispatch(fetchCustomAttributes()),
  }
}

export default connect(
  mapState,
  mapDispatch,
)(requireAuthentication(UserEditContainer))
